export const SITE_URL = 'https://freedmanlabs.com';
export const SITE_NAME = 'Freedman Labs';
export const SITE_TAGLINE = 'Video Editing Apps, Built by Editors for Editors';
export const DEFAULT_TITLE = `${SITE_NAME} - ${SITE_TAGLINE}`;
export const DEFAULT_DESCRIPTION =
  'Video editing apps built by editors, for editors. Apps for post-production teams: WatchMyEdit, PrepMyMedia, ViewMyAttic, and TrackMyPost.';
export const DEFAULT_IMAGE = `${SITE_URL}/images/logo.png`;

/** In dev, hit live Hostinger PHP (CORS enabled). In production, same-origin. */
export const stripeApiBase =
  process.env.NODE_ENV === 'development' ? SITE_URL : '';

export const stripeApiUrl = (path) => `${stripeApiBase}${path}`;

export const productPath = (productId) => `/apps/${productId}`;
export const purchasePath = (productId) => `/apps/${productId}/purchase`;
export const purchaseSuccessPath = (productId) => `/apps/${productId}/purchase/success`;

export const isWebApp = (product) => Boolean(product?.externalUrl);

export const macAppProducts = (products = []) =>
  products.filter((product) => !isWebApp(product));

export const productMeta = (product) => ({
  title: `${product.title} - ${product.app.tagline} | ${SITE_NAME}`,
  description: product.app.description,
  canonical: isWebApp(product) ? product.externalUrl : `${SITE_URL}${productPath(product.id)}`,
  image: `${SITE_URL}${product.app.image}`,
});
